<dx-popup
    #writeoffEditorBox
    width="45%"
    height="40%"
    title="Write-off Adjustment"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onHidden)="onHidden($event)"
>
    <div *dxTemplate="let item of 'content'" class="ar-adjustment-writeoff-editor-content">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <dx-form
                    #writeOffAdjustmentForm
                    width="100%"
                    height="100%"
                    [colCount]="2"
                    [labelLocation]="defaultLabelLocation"
                >
                    <dxi-item>
                        <dxo-label text="Write-off Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box [width]="100" [(value)]="writeOffParam.writeOffDate" type="date"></dx-date-box>
                        </div>
                    </dxi-item>

                    <dxi-item *ngIf="arAdjustmentItems.length === 1">
                        <dxo-label text="Write-off Amount"></dxo-label>
                        <div *dxTemplate>
                            <dx-number-box
                                [width]="100"
                                [(value)]="writeOffAmount"
                                [format]="currencyFormat"
                            ></dx-number-box>
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty" *ngIf="arAdjustmentItems.length > 1"></dxi-item>
                    <dxi-item [colSpan]="2" *ngIf="arAdjustmentItems.length > 1">
                        <dx-data-grid
                            #writeOffAdjustmentGrid
                            class="cc-vertical-center-cell-data-grid"
                            width="100%"
                            height="90%"
                            [dataSource]="arAdjustmentItems"
                            [allowColumnReordering]="true"
                            [allowColumnResizing]="true"
                            [columnAutoWidth]="true"
                            [showBorders]="true"
                            [showColumnLines]="true"
                            [showRowLines]="true"
                            noDataText="No data to display"
                        >
                            <dxi-column
                                dataField="isSelect"
                                caption="Select"
                                alignment="center"
                                cellTemplate="selectTemplate"
                                [width]="70"
                            ></dxi-column>
                            <dxi-column
                                dataField="writeOffAmount"
                                caption="Write Off Amount"
                                dataType="number"
                                cellTemplate="applyAmountTemplate"
                                [width]="120"
                                [format]="currencyFormat"
                            ></dxi-column>

                            <dxi-column dataField="description" caption="Description" dataType="string"></dxi-column>

                            <dxi-column
                                dataField="amount"
                                caption="Amount"
                                dataType="number"
                                [format]="currencyFormat"
                            ></dxi-column>
                            <dxi-column
                                dataField="openBalance"
                                caption="Due Amount"
                                dataType="number"
                                [format]="currencyFormat"
                            ></dxi-column>

                            <div *dxTemplate="let row of 'applyAmountTemplate'">
                                <dx-number-box
                                    [format]="currencyFormat"
                                    [(value)]="row.value"
                                    (onValueChanged)="applyAmountChanged($event, row.data)"
                                ></dx-number-box>
                            </div>

                            <div *dxTemplate="let row of 'selectTemplate'">
                                <dx-check-box [(value)]="row.data.isSelect"></dx-check-box>
                            </div>

                            <dxo-header-filter [visible]="false"></dxo-header-filter>
                            <dxo-filter-panel [visible]="false"></dxo-filter-panel>
                            <dxo-group-panel [visible]="false"></dxo-group-panel>
                            <dxo-sorting mode="none"></dxo-sorting>
                            <dxo-scrolling mode="standard"></dxo-scrolling>
                            <dxo-load-panel [enabled]="false"></dxo-load-panel>
                        </dx-data-grid>
                    </dxi-item>
                </dx-form>
            </dxi-item>

            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Cancel"
                                [icon]="closeIcon"
                                (onClick)="onHidden($event)"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Write Off"
                                useSubmitBehavior="true"
                                [icon]="saveIcon"
                                (onClick)="onWriteOffClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#writeOffAdjustmentForm' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
